// Seller "hide prices" mode (spec 2026-10-22-seller-hide-prices-design).
// Catalog prices ONLY (Volkan 2026-10-25): catalog prices are not final yet,
// every other amount (wallet, orders, home, reports) stays visible. The server
// nulls money on catalog responses; this flag makes the shared formatters print
// "—" on catalog screens and lets them drop price-only controls (sort by price,
// profit calculator).
import { create } from 'zustand'

type PriceMaskState = { hidden: boolean; setHidden: (hidden: boolean) => void }

export const usePriceMaskStore = create<PriceMaskState>((set) => ({
  hidden: false,
  setHidden: (hidden) => set({ hidden }),
}))

export const PRICE_MASK = '—'

// The only screens whose amounts are masked: the PEXIFY catalog.
const MASKED_PATH_PREFIXES = ['/seller/catalog'] as const

function onMaskedPath(): boolean {
  if (typeof window === 'undefined') return false
  const path = window.location.pathname
  return MASKED_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))
}

/** Non-React read for formatters. */
export function pricesMasked(): boolean {
  return usePriceMaskStore.getState().hidden && onMaskedPath()
}

export function usePricesHidden(): boolean {
  return usePriceMaskStore((s) => s.hidden)
}
